"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var glide_1 = require("@glidejs/glide");
var Glide2 = require("@glidejs/glide");
var common_1 = require("../utils/common");
var Carousel = /** @class */ (function () {
    function Carousel(documentObject) {
        var GlideRef = glide_1.default ? glide_1.default : Glide2;
        var elements = documentObject.querySelectorAll('.js-carousel');
        var that = this;
        if (elements) {
            elements.forEach(function (element) {
                var perView = element.dataset.perView ? parseInt(element.dataset.perView) : 1;
                var hasYouTubeBanner = element.querySelector('.c-banner--youtube');
                var isFade = element.dataset.type === 'fade';
                var autoPlay = element.dataset.autoplay;
                var options = {
                    type: hasYouTubeBanner ? 'slider' : 'carousel',
                    perView: perView,
                    perSwipe: '|',
                    animationDuration: isFade && !hasYouTubeBanner ? 0 : 500,
                    autoplay: autoPlay === "true" ? 8000 : false,
                    startAt: 0,
                    gap: perView > 1 ? 20 : 0,
                    breakpoints: {
                        768: {
                            perView: 1,
                            gap: 0
                        }
                    },
                    slider: 'c-carousel--slider',
                    carousel: 'c-carousel--carousel',
                    swipeable: 'c-carousel--swipeable',
                    dragging: 'c-carousel--dragging',
                    cloneSlide: 'c-carousel__slide--clone',
                    activeNav: 'c-carousel__bullet--active'
                };
                // If mount at creation (default true)
                if (element.dataset.mount == 'false') {
                    element.addEventListener('mountCarousel', function (event) {
                        that.formatCarousel(element, documentObject, perView, options, GlideRef);
                    });
                }
                else {
                    that.formatCarousel(element, documentObject, perView, options, GlideRef);
                }
            });
        }
    }
    Carousel.prototype.videoBannerPausePlay = function (glide, element, bullets, numberOfItems) {
        var YT = window['YT'];
        var activeSlide = null;
        var youtubeSlide = null;
        var videoElem = null;
        var player = null;
        glide.on('build.after', function () {
            YT = window['YT'];
            var notActiveSlides = element.querySelectorAll('.c-carousel__slide:not(.glide__slide--active)');
            notActiveSlides.forEach(function (element) {
                youtubeSlide = element.querySelector('.c-banner--youtube');
                videoElem = element.querySelector('.c-banner__background-video');
                if (youtubeSlide) {
                    var iframeId = 'video' + youtubeSlide.dataset.video;
                    if (YT !== undefined && YT !== null) {
                        if (YT.get) {
                            player = YT.get(iframeId);
                            if (player) {
                                if (player.pauseVideo) {
                                    player.pauseVideo();
                                }
                            }
                        }
                    }
                }
                else if (videoElem) {
                    videoElem.pause();
                }
            });
        });
        glide.on('run.after', function () {
            YT = window['YT'];
            activeSlide = element.querySelector('.glide__slide--active');
            if (activeSlide) {
                youtubeSlide = activeSlide.querySelector('.c-banner--youtube');
                videoElem = activeSlide.querySelector('.c-banner__background-video');
            }
            if (youtubeSlide) {
                var iframeId = 'video' + youtubeSlide.dataset.video;
                if (YT !== undefined && YT !== null) {
                    if (YT.get) {
                        player = YT.get(iframeId);
                        if (player) {
                            player.playVideo();
                        }
                    }
                }
            }
            else if (videoElem) {
                videoElem.play();
            }
        });
        glide.on('run.before', function (evt) {
            YT = window['YT'];
            if (youtubeSlide) {
                if (YT !== undefined && YT !== null) {
                    if (player) {
                        if (player.pauseVideo) {
                            player.pauseVideo();
                        }
                    }
                }
                youtubeSlide = null;
            }
            else if (videoElem) {
                videoElem.pause();
                videoElem = null;
            }
            // Fix carousel movement for multiple items
            if (glide.settings.perView != 1) {
                var scrollSteps = glide.settings.perView;
                if (evt.direction != '=') {
                    var isLastSection = numberOfItems - (glide.index + scrollSteps) == 0;
                    if (isLastSection) {
                        evt.steps = (numberOfItems - scrollSteps);
                    }
                    else if (evt.direction === '>') {
                        evt.steps = -(scrollSteps);
                    }
                    else {
                        if (glide.index == 0) {
                            evt.steps = 0;
                            evt.direction = '=';
                        }
                        else {
                            evt.steps = scrollSteps;
                        }
                    }
                }
            }
        });
    };
    Carousel.prototype.formatCarousel = function (element, documentObject, perView, options, GlideRef) {
        var _this = this;
        setTimeout(function () {
            var numberOfItems = element.querySelectorAll('.c-carousel__slide').length;
            var bullets = element.querySelectorAll('.c-carousel__bullet');
            for (var i = 0; i < bullets.length; i++) {
                var bullet = bullets[i];
                if (i % perView != 0) {
                    bullet.classList.add('d-md-none');
                }
            }
            if (numberOfItems === 1) {
                element.classList.add('c-carousel--hide-controls');
                options.type = 'slider';
            }
            else if (numberOfItems <= perView) {
                element.classList.add('c-carousel--hide-controls-medium');
                options.type = 'slider';
            }
            var glide = new GlideRef(element, options);
            if (element) {
                glide.mount();
                _this.videoBannerPausePlay(glide, element, bullets, numberOfItems);
            }
            // Set behavior depending on number of items
            // If only one item then no interaction
            if (numberOfItems === 1) {
                glide.disable();
            }
            // If number of items is the same as per view no interaction should 
            // be available on large devices
            else if (numberOfItems <= perView && common_1.default.getDeviceWidth() > 767) {
                glide.disable();
            }
        }, 100);
    };
    return Carousel;
}());
exports.default = Carousel;
